import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers';
import { IdCardsForm } from './components/IdCardsForm';
import { ID_CARDS_FORM_NAME } from 'Common/FormEnum';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { IdCardsFieldEnum as Fields } from 'Common/FieldEnum';
import {
  uniqueIdentifierEnum,
  sortByEnum,
  displayOptions,
  defaultReportModel,
} from './Constants';
import {
  getInitialData,
  getGrades,
  getReport,
  clearReport,
  clearErrors,
} from '../idcards/state/idcards/actions';
import * as selectors from '../idcards/state/selector';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { ReportGeneration } from 'Common/ObjectHelper';
import { errorToast } from 'Common/ToastHelper';
import { getSelectedStatuses, getSpecificStudents } from './helpers';

class IdCardsContainer extends Component {
  getMainProps = () => {
    return {
      toolbox: {
        formName: ID_CARDS_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: false,
          disabled: false,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    const { getInitialData, getGrades } = this.props;
    getInitialData('ALL');
    getGrades();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;
    if (report && prevState !== report) {
      ReportGeneration(report, 'ID Cards Report');
      this.props.clearReport();
    }

    if (errorToast(this.props, prevProps, 'fetchError')) {
      this.props.clearErrors();
    }
  }

  selectedSites = site => {
    const { sites } = this.props;

    if (site.toUpperCase() === 'ALL') {
      return sites.map(x => {
        return x.Id;
      });
    }

    return sites
      .filter(x => {
        return x.Id === site;
      })
      .map(x => {
        return x.Id;
      });
  };

  formSubmit = formValues => {
    let values = defaultReportModel;

    values = {
      ...values,
      MealStatus: getSelectedStatuses(formValues),
      UniqueIdentifierStudentNumber: formValues[Fields.UniqueIdentifier],
      FilterBySiteId: this.selectedSites(formValues[Fields.Site]),
      FilterByTeacherName:
        formValues[Fields.Teacher].toUpperCase() === 'ALL'
          ? ''
          : formValues[Fields.Teacher],
      FilterByGrade: formValues[Fields.Grade].includes('ALL')
        ? []
        : formValues[Fields.Grade],
      FilterByStudentNumber: getSpecificStudents(formValues),
      DisplayBarcode: formValues[Fields.DisplayBarcode],
      DisplayPicture: formValues[Fields.DisplayPicture],
      DisplaySiteName: formValues[Fields.DisplaySiteName],
      DisplayUniqueIdentifier: formValues[Fields.DisplayUniqueIdentifier],
      SortBy: formValues[Fields.SortBy],
    };

    this.props.getReport(values);
  };

  onSiteChange = site => {
    this.props.getInitialData(site);
  };

  onGradeChange = (e, items) => {
    const allIndex = items.indexOf('ALL');

    if (allIndex === 0 && items.length > 1) {
      items.splice(0, 1);
    }
    if (allIndex > 0 && items.length > 1) {
      items.splice(0, allIndex);
    }
    if (items.length === 0) {
      items.push('ALL');
    }
  };

  statusCheckboxes = () => {
    return Object.values(StatusEnum)
      .filter(f => f !== '0')
      .map(value => ({
        name: `Statuses${value}`,
        label: value,
        checked: true,
      }));
  };

  initialValues = () => {
    let initialValues = {
      [Fields.UniqueIdentifier]: uniqueIdentifierEnum.StudentNumber,
      [Fields.SortBy]: sortByEnum.StudentName,
      [Fields.Site]: 'ALL',
      [Fields.Teacher]: 'ALL',
      [Fields.Grade]: ['ALL'],
      All: true,
    };

    displayOptions.forEach(x => {
      Object.defineProperty(initialValues, `${x.name}`, {
        value: x.checked,
        writable: true,
        enumerable: true,
      });
    });

    this.statusCheckboxes().forEach(x => {
      Object.defineProperty(initialValues, `${x.name}`, {
        value: x.checked,
        writable: true,
        enumerable: true,
      });
    });

    return initialValues;
  };

  render() {
    const { loading, teachers, gradeOptions } = this.props;

    return (
      <Fragment>
        {loading ? <LoadingPage /> : undefined}
        <Filter title={'ID Cards'} />
        <Main {...this.getMainProps()}>
          <IdCardsForm
            onSubmit={this.formSubmit}
            initialValues={this.initialValues()}
            teachers={teachers}
            gradeOptions={gradeOptions}
            onGradeChange={this.onGradeChange}
            onSiteChange={this.onSiteChange}
            statusCheckboxes={this.statusCheckboxes()}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    sites: state.CommonState.sites.info.Data,
    teachers: selectors.getTeachers(state),
    loading: selectors.getLoading(state),
    report: selectors.getReport(state),
    fetchError: selectors.getFetchError(state),
    gradeOptions: selectors.getGradeOptions(state),
  };
};

const mapDispatchToProps = {
  getInitialData,
  getGrades,
  getReport,
  clearReport,
  clearErrors,
};

export const IdCards = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IdCardsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/idcards/IdCards.js